import { useCallback } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Nomination from 'components/atoms/CustomSVGIcon/Nomination';
import { KMP_DEALER_NOMINATION } from 'features/common/acl/constants';
import user from 'features/views/user';
import { USER_ROLE } from 'features/views/user/constants';
import { getRoutePath } from 'utils';

const CampaignNominationsButtons = (props) => {
	const { campaign, currentRole, allowedChannels } = props;
	const { id, nominationDate } = campaign;
	const navigate = useNavigate();

	const showRegionNominations = [
		USER_ROLE.CENTRAL,
		USER_ROLE.AGENCY_MANAGER,
		USER_ROLE.REGION_MANAGER,
		USER_ROLE.DISTRICT_MANAGER,
	].includes(currentRole);

	const showSubsellerNominations =
		[USER_ROLE.GROUP_MANAGER].includes(currentRole) &&
		allowedChannels.includes(campaign.channelId) &&
		!showRegionNominations;

	const handleRedirect = useCallback(
		(page) => () => {
			const { pathname, state } = getRoutePath(page, { campaignId: id }, true);
			navigate(pathname, { state });
		},
		[id, navigate],
	);

	if (!nominationDate) {
		return null;
	} else {
		return (
			<AccessControl accessLevel={KMP_DEALER_NOMINATION}>
				{showRegionNominations && (
					<Tooltip title={getLabelMessage('campaign:nominationDate')}>
						<IconButton
							sx={{ color: 'primary.main', fontSize: 20, p: 0 }}
							disableRipple
							onClick={handleRedirect('campaignRegionNomination')}
						>
							<Nomination />
						</IconButton>
					</Tooltip>
				)}
				{showSubsellerNominations && (
					<Tooltip title={getLabelMessage('campaign:nominationDate')}>
						<IconButton
							sx={{ color: 'primary.main', fontSize: 20, p: 0 }}
							disableRipple
							onClick={handleRedirect('campaignSubsellerNomination')}
						>
							<Nomination />
						</IconButton>
					</Tooltip>
				)}
			</AccessControl>
		);
	}
};

CampaignNominationsButtons.propTypes = {
	allowedChannels: PropTypes.array,
	campaign: PropTypes.shape({
		id: PropTypes.number,
		nominationDate: PropTypes.bool,
		channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	}),
	currentRole: PropTypes.string,
};

export default connect((state) => ({
	currentRole: user.selectors.getInfo(state).currentRole,
	allowedChannels: user.selectors.getAllowedChannels(state),
}))(CampaignNominationsButtons);
